<template>
  <div class="solutionDeail">
    <!--头部banner-->
    <div class="banner"></div>
    <!-- 板块选择 -->
    <div class="plateSelect w">
      <div class="plateItem" v-for="(item,i) in SolutionsLists" :key="i" @click="toSelectPlate(item.id)" :style="item.id==solutionIdChecked?'color:#fff;border-color:#3868e9;background-color:#3868e9':''">
        {{item.solutionName}}
      </div>
    </div>
    <!--主体-->
    <div class="main">
      <el-row>
        <el-col :span="4">
          <div class="grid-content bg-purple">
            <div class="left_news">
              <span>推荐商家</span>
              <!-- <span>排行</span> -->
              <ul v-if="allShopLists.length>0">
                <li @click="msginfoDeail(item.id),msgCheckID=item.id" v-for="(item,index) in allShopLists" :key="index"><span :style="msgCheckID==item.id?'color:#3868e9;':''">{{item.shopName}}</span></li>
              </ul>
              <div v-else style="width:100%;height:100px;line-height:100px;text-align:center;color:#666;background-color:#f5f7fa;">暂无商家</div>
            </div>
          </div>
        </el-col>
        <el-col :span=" 20">
          <div class="grid-content bg-purple-light">
            <div class="right">
              <div class="content" v-if="msgInfo.solutionTitle">
                <div class="bannerMiddle" v-if="msgInfo.shopInfo">
                  <div class=" bannerMiddleBox">
                    <el-image style="width: 130px; height: 130px; margin-right: 20px;border-radius: 50%;" :src="msgInfo.shopInfo.shopLogo" fit="cover"></el-image>
                    <div class="bannerMiddleBox_info" @click="toShopDeail(msgInfo.shopInfo.id,msgInfo.supplierInfo.id)">
                      <div class="bannerMiddleBox_Title 0f-1">
                        {{msgInfo.shopInfo.shopName}}
                      </div>
                      <div class="bannerMiddleBox_main of-4">
                        {{msgInfo.shopInfo.shopIntroduce || '--'}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="title">{{ msgInfo.solutionTitle }}</div>
                <div class="desc">
                  <span v-if="msgInfo.solutionCategory">分类：{{ msgInfo.solutionCategory.solutionName }}</span>
                  <span v-if="msgInfo.createTime">时间：{{ msgInfo.updateTime ||msgInfo.createTime }}</span>
                </div>
                <div class="" style="padding:25px" v-html="msgInfo.solutionContent"></div>
              </div>
              <div v-else class="content" style="width:100%;height:400px;line-height:400px;text-align:center;color:#666;background-color:#f5f7fa;"> 暂无数据</div>
            </div>
          </div>

        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  export default {
    name: "solutionDeail",
    data() {
      return {
        allShopLists: [], //店铺列表
        SolutionsLists: [], //板块列表
        solutionIdChecked: '', //板块id
        msgInfo: {}, //解决方案内容
        msgCheckID: '', //解决方案id
      }
    },
    created() {
      //   console.log(this.$route.params)
      // 板块
      this.$http.post(this.$const.SellerCenter.solutionCategory, "")
        .then((res) => {
          console.log("解決方案板块数据:", res);
          if (res.code == 200) {
            this.SolutionsLists = res.data;
            this.solutionIdChecked = this.$route.params.solutionPlateID || this.SolutionsLists[0].id;
            this.getsolutionPageInfo()
          } else {
            // this.$message.error(this.$PubText.getInfoFail);
          }
        })
        .catch((error) => {
          // this.$message.error(this.$PubText.InterfaceFail);
        });

    },

    methods: {
      // 获取当前板块下的店铺
      getsolutionPageInfo() {
        var params = {
          "pageNum": 1,
          "pageSize": 100,
          "shelfStatus": 1,
          "solutionCategoryId": this.solutionIdChecked,
          "solutionTitle": "",
          "status": 1,
          "supplierInfoId": ""
        }
        this.$http.post(this.$const.SellerCenter.getSolutionList, params)
          .then((res) => {
            if (res.code == 200) {
              this.allShopLists = res.data.list;
              this.msgCheckID = this.$route.params.solutionID || this.allShopLists[0].id;
              this.msginfoDeail(this.msgCheckID)
            } else {
              // this.$message.error(this.$PubText.getInfoFail);
            }
          })
          .catch((error) => {
            // this.$message.error(this.$PubText.InterfaceFail);
          });
      },
      //   切换板块
      toSelectPlate(id) {
        this.solutionIdChecked = id;
        this.msgInfo = {}; //解决方案内容
        this.msgCheckID = ''; //解决方案id
        this.getsolutionPageInfo()
      },
      //   文章详情
      msginfoDeail(id) {
        this.$http.get(this.$const.SellerCenter.solutionGetOne + id, '')
          .then((res) => {
            if (res.code == 200) {
              this.msgInfo = res.data;
            } else {
              // this.$message.error(this.$PubText.getInfoFail);
            }
          })
          .catch((error) => {
            // this.$message.error(this.$PubText.InterfaceFail);
          });

      },
      //点击跳转新闻详情页
      toShopDeail(shopId, supplierId) {
        let routeUrl = this.$router.resolve({
          name: "companyInfo",
          query: {
            shopId: shopId,
            supplierId: supplierId,
          }
        });
        window.open(routeUrl.href, '_blank');
      },
    }
  }
</script>

<style scoped lang="scss">
  .solutionDeail {
    .banner {
      width: 100%;
      min-width: 1200px;
      height: 45vh;
      background: url('~@/assets/image/solutionBanner.png') no-repeat;
      background-size: 100% 100%;
      background-position: center;
    }

    .plateSelect {
      display: flex;
      margin-top: 20px;

      .plateItem {
        padding: 0 20px;
        margin-right: 20px;
        line-height: 45px;
        border: 1px solid #ccc;
        color: #888;
        cursor: pointer;
      }
    }

    .main {
      margin: 20px;

      .left_news {
        width: 100%;


        &>span {
          font-size: 20px;
          width: 100%;
          line-height: 45px;
          display: inline-block;
          background: #3868e9;
          color: #fff;
          padding: 0 20px;
          font-weight: bold;
        }

        &>span:nth-child(2) {
          background: #f5f7fa;
          color: black;
          border-bottom: 1px solid #e6e6e6;
        }

        ul {
          width: 100%;
          list-style: none;
          padding: 5px 20px;
          background: #f5f7fa;

          li {
            margin: 15px 0;
            position: relative;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            cursor: pointer;
            color: #666666;

            &>span {
              margin-left: 20px;
            }
          }

          li::before {
            content: '';
            display: table;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background: #cccccc;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }

      .newsbox {
        width: 100%;
        margin-bottom: 20px;

        p {
          font-size: 24px;
          display: flex;
          align-items: center;
          padding-right: 30px;

          span {
            max-width: 400px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            cursor: pointer;

            &:hover {
              color: #678eed;
            }
          }

          .el-button--danger {
            background-color: transparent;
            color: #F56C6C;
            border-color: #F56C6C;
            cursor: auto;
            margin-left: 50px;
          }

          .el-button--mini,
          .el-button--mini.is-round {
            padding: 5px 20px;
          }
        }

        .newsinfo {
          height: 250px;
          padding: 25px 0;
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid #e0e0e0;

          .imgbox {
            width: 350px;
            height: 200px;
            overflow: hidden;
            border-radius: 10px;

            img {
              width: 100%;
              height: 100%;
              transition: all .5s;
            }

            img:hover {
              transform: scale(1.1);
            }
          }

          .info {
            width: calc(100% - 400px);
            position: relative;

            p {
              font-size: 12px;
              color: #999999;
            }

            div {
              margin-top: 20px;
              color: #666666;
              line-height: 3;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3; //显示行数
            }

            .seemore {
              position: absolute;
              bottom: -20px;
              right: 20px;
              color: #5a8beb;
              cursor: pointer;
            }
          }
        }
      }

      .newsList {
        ul {
          min-height: 100px;

          li {
            height: 60px;
            line-height: 60px;
            border-bottom: 1px dashed #e9e9e9;
            display: flex;
            justify-content: space-between;
            font-size: 14px;
            cursor: pointer;

            .name {
              display: inline-block;
              width: 650px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .name:hover {
              color: #3867e9;
            }
          }
        }
      }

      .pagination {
        margin: 20px 0;
        text-align: center;
      }


      .title {
        text-align: center;
        font-size: 35px;
        line-height: 55px;
        padding: 10px 0;
      }

      .desc {
        color: #909090;
        font-size: 15px;
        margin: 0 0 15px 0;
        text-align: center;

        span:nth-child(2) {
          margin-left: 140px;
        }
      }

      .right {
        width: 100%;
        padding: 0 50px 0 20px;

        .content {
          width: 100%;
          min-height: 400px;
          //   height: $height;
          background: #fff;
          margin: 0 auto;
          border: 1px solid #dde4ea;
          // padding: 25px;
          overflow-y: auto;
          scrollbar-width: none;
          /* firefox */
          -ms-overflow-style: none;
          /* IE 10+ */

          &::-webkit-scrollbar {
            /* Chrome Safari */
            display: none
          }


        }
      }

      //   .content {
      //     min-height: 400px;
      //   }
    }

    .bannerMiddleBox_main {
      height: 80px;
      line-height: 20px;
      font-size: 16px;
    }

    .bannerMiddleBox_Title {
      height: 40px;
      line-height: 40px;
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 10px;
    }

    .bannerMiddleBox_info {
      flex: 1;
      cursor: pointer;
      height: 130px;
    }

    .bannerMiddleBox {
      display: flex;
      align-items: center;
      padding: 30px;
    }

    .bannerMiddle {
      position: relative;
      width: 100%;
      margin: 0;
      // height: 245px;
      background-image: url("../../assets/imgs/home/bg3.png");
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    }

  }
</style>
